import { apiEndPoint } from "./endPoint";

export const getChatManualConfirmStatus = async (
  userId: string,
  token: string
) => {
  const url = `${apiEndPoint}/getChatManualConfirmData/${userId}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return "エラーが発生しました: ${err.message}";
  }
};
